function isDarkColor(colorString) { /// принимает либо "rgb(255, 255, 221)",
    // либо "#f4f6fb" и возвращает true, если цвет ближе к темным, иначе false.
    // Если некорректная строка, то null
  // 1. Нормализуем строку: убираем пробелы, приводим к нижнему регистру
  if (typeof colorString !== 'string')
    return null;
  const normalized = colorString.trim().toLowerCase();

  // 2. Парсим RGB-компоненты
  let r, g, b;

  // Проверяем, является ли строка HEX-форматом (#f4f6fb)
  if (normalized.startsWith('#')) {
    const hex = normalized.replace('#', '');
    // Поддерживаем как короткий (#fff), так и полный (#ffffff) формат
    if (hex.length === 3) {
      // Короткий формат: #f4f -> разворачиваем в #ff44ff
      const expanded = hex.split('').map(c => c + c).join('');
      r = parseInt(expanded.substring(0, 2), 16);
      g = parseInt(expanded.substring(2, 4), 16);
      b = parseInt(expanded.substring(4, 6), 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else {
      return null; // Некорректный HEX
    }
  }
  // Проверяем, является ли строка RGB-форматом (rgb(255, 255, 221))
  else if (normalized.startsWith('rgb(') && normalized.endsWith(')')) {
    const values = normalized
      .replace('rgb(', '')
      .replace(')', '')
      .split(',')
      .map(v => parseInt(v.trim(), 10));

    if (values.length === 3 && values.every(v => !isNaN(v) && v >= 0 && v <= 255)) {
      r = values[0];
      g = values[1];
      b = values[2];
    } else {
      return null; // Некорректные значения RGB
    }
  } else {
    return null; // Неподдерживаемый формат
  }

  // 3. Проверяем, что компоненты получены
  if (r === undefined || g === undefined || b === undefined) {
    return null;
  }

  // 4. Вычисляем яркость по формуле (воспринимаемая яркость)
  // Используем формулу для линейного RGB: L = 0.2126 * R + 0.7152 * G + 0.0722 * B
  const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // 5. Возвращаем true, если яркость меньше порога (128), иначе false
  return brightness < 128;
}

export default isDarkColor;